import { render, staticRenderFns } from "./bulma_upload.vue?vue&type=template&id=39978c92&scoped=true"
import script from "./bulma_upload.vue?vue&type=script&lang=js"
export * from "./bulma_upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39978c92",
  null
  
)

export default component.exports